import React, { Component } from "react";
import { Placeholder } from "semantic-ui-react";
import { isEmpty } from "lodash";
import ReadAxios from "../axiosComponent/read";

export class Name extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
    };
  }

  componentDidMount() {
    this.getname();
  }

  getname = () => {
    ReadAxios({ url: `${this.props.url}/${this.props.id}` })
      .then((res) => {
        return isEmpty(res.data.resultSet)
          ? "NA"
          : this.setState({
              name: res.data.resultSet[0][this.props.keyIndex],
            });
      })
      .catch((err) => {
        return "NA";
      });
  };

  render() {
    return this.state.name ? (
      <>{this.state.name}</>
    ) : (
      <Placeholder fluid>
        <Placeholder.Header>
          <Placeholder.Line />
        </Placeholder.Header>
      </Placeholder>
    );
  }
}

export default Name;
